/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class SecurityInternalGrid extends SiteEntityGrid<SecurityInternalRow, any> {
        protected getColumnsKey() { return 'Data.SecurityInternal'; }
        protected getDialogType() { return SecurityInternalDialog; }
        protected getIdProperty() { return SecurityInternalRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityInternalRow.localTextPrefix; }
        protected getService() { return SecurityInternalService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}